import { render, staticRenderFns } from "./AddNewCrmSubjectsPopUp.vue?vue&type=template&id=6956e20e&scoped=true&"
import script from "./AddNewCrmSubjectsPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewCrmSubjectsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCrmSubjectsPopUp.vue?vue&type=style&index=0&id=6956e20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6956e20e",
  null
  
)

export default component.exports